<template>
  <div
    class="c-userIcon"
    :class="{ '-is-editable': isEditable }"
  >
    <div class="c-userIcon_imgWrapper">
      <CUserIconV2
        :file-path="filePath"
        :user-name="name"
        :size="(isPC || isTB) ? 120 : 64"
        :width="240"
        :height="240"
        class="c-userIcon_img"
        :class="{ 'c-userIcon_img-show': hasDeviceJudged }"
        v-if="hasDeviceJudged"
      />
    </div>
    <a
      class="c-userIcon_control"
      :href="$coconala.url('/mypage/user/info')"
      v-if="isEditable"
    >
      <CoconalaIcon name="camera-plus" color="primary" />
    </a>
  </div>
</template>
<script>
// vuex
import { mapGetters } from 'vuex'

export default {
  props: {
    filePath: {
      type: String
    },
    name: {
      type: String
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'hasDeviceJudged'])
  }
}
</script>
<style lang="scss" scoped>
.c-userIcon {
  position: relative;
  max-width: 120px;
  max-height: 120px;
  text-align: center;
  &_img {
    // カクつきの防止
    display: none;
    border: 5px solid $color-white;

    &-show {
      display: block;
    }
  }
  &_control {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.7);
    @include link-effect;
    i {
      font-size: 35px;
    }
  }
  // 画像表示までの高さ確保用
  &_imgWrapper {
    min-height: 120px;
  }
}

@media (max-width: $breakpoint-l) {
  .c-userIcon {
    max-width: 120px;
    max-height: 120px;
    &_control {
      i {
        font-size: 30px;
      }
    }
  }
}

@media (max-width: $breakpoint-s) {
  .c-userIcon {
    max-width: 64px;
    img {
      border-width: 2px;
    }
    &_control {
      i {
        font-size: 20px;
      }
    }
    // 画像表示までの高さ確保用
    &_imgWrapper {
      min-height: 64px;
    }
  }
}
</style>
